import React from 'react'
import styled from '@emotion/styled'
import { colors, font, radius } from '@mobi/component-library/Theme/Common'
import { unicodeToEmoji } from '@core/Areas/FollowMe/helpers/unicodeToEmojiConverter'
import { ProfileImage } from './Components/ProfileImage'

type Size = 'xs' | 'sm' | 'lg'

export const ProfileAvatar: React.FC<{
  avatar?: string
  color?: string
  size?: Size
}> = ({ avatar = 'U+1F34B', color = 'linear-gradient(180deg, #FFF, #A0E528)', size = 'sm' }) => {
  const isProfileImage = avatar.startsWith('http')
  return (
    <WrapperStyled
      className={`follow-me__avatar--${size}`}
      style={{ background: isProfileImage ? colors.white : color }}
    >
      {isProfileImage ? (
        <ProfileImage url={avatar} shouldDisplayCheck={size === 'sm'} />
      ) : (
        unicodeToEmoji(avatar)
      )}
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  flexShrink: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: radius.full,
  fontFamily: font.family.primary,
  lineHeight: 1,
  textDecoration: 'none',
  cursor: 'pointer',

  '&.follow-me__avatar--xs': {
    height: '2.4rem',
    width: '2.4rem',
    fontSize: '1.4rem',
  },

  '&.follow-me__avatar--sm': {
    width: '3.6rem',
    height: '3.6rem',
    fontSize: '2.4rem',
  },

  '&.follow-me__avatar--lg': {
    width: '12rem',
    height: '12rem',
    fontSize: '8rem',
  },
})
